import { useRef } from 'react';

import { useLegalClientSaveKnowledgeAndExperience } from 'api/requests';
import { useTranslation } from 'libs/i18n';

import { KnowledgeAndExperienceFormType } from '../forms/knowledgeAndExperienceForm';
import {
  getInitialData,
  getSubmitData,
} from '../helpers/knowledgeAndExperience';

import { useOnboardingContext } from './useOnboardingContext';

export const useKnowledgeAndExperience = () => {
  const { t } = useTranslation();
  const { data, goToBack, goToNext } = useOnboardingContext();

  const {
    error,
    loading: submitLoading,
    saveKnowledgeAndExperience: saveFinancialPositionApi,
  } = useLegalClientSaveKnowledgeAndExperience();

  const initialValues = useRef(
    getInitialData(t, data.legalClient!.knowledgeAndExperience)
  ).current;

  const onSubmit = async (values: KnowledgeAndExperienceFormType) => {
    const submitData = getSubmitData(values);
    await saveFinancialPositionApi(data.legalClient!.id, submitData);
    goToNext();
  };

  return {
    initialValues,
    submitLoading,
    error,
    goToBack,
    onSubmit,
  };
};
